/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosAddressPortfolioCoinInfo = {
    COINID: string;
    ASTTP: string;
    NN: string;
    SB: string;
    LOGO: string;
    AMT: string;
    PRC: string;
    VAL: string;
    PCT: AptosAddressPortfolioCoinInfo.PCT;
    PST: AptosAddressPortfolioCoinInfo.PST;
};

export namespace AptosAddressPortfolioCoinInfo {

    export enum PCT {
        NATIVE = 'NATIVE',
        EMOJICOIN = 'EMOJICOIN',
        MEME = 'MEME',
        BRIDGED = 'BRIDGED',
        NONE = 'NONE',
    }

    export enum PST {
        VERIFIED = 'VERIFIED',
        RECOGNIZED = 'RECOGNIZED',
        UNVERIFIED = 'UNVERIFIED',
        BANNED = 'BANNED',
        INTERNAL_FA = 'INTERNAL_FA',
        LP = 'LP',
        NONE = 'NONE',
    }


}

